import { useEffect, useMemo, useState, useRef } from 'react';
import {
    MaterialReactTable,
    MRT_Cell,
    useMaterialReactTable,
    type MRT_ColumnDef,
    type MRT_TableOptions,
} from 'material-react-table';
import { Chip, Pagination, Typography, TextField, Button, Box, InputAdornment, useMediaQuery, Menu, MenuItem, PaginationItem } from '@mui/material';
import searchIcon from 'packages/novous_web/src/assets/icons/Icon.svg'
import filterIcon from 'packages/novous_web/src/assets/icons/Filter.svg'
import Custom from 'packages/novous_web/src/assets/icons/CustomBlue.svg'
import emailReportIcon from 'packages/novous_web/src/assets/icons/EmailReport.svg'
import downloadWhiteIcon from 'packages/novous_web/src/assets/icons/downloadWhiteIcon.svg'
import CustomIconButton from 'packages/novous_web/src/common/components/CustomIconButton';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { API_ENDPOINTS } from 'packages/novous_web/src/api/endpoints';
import useAxios from 'packages/novous_web/src/api/useAxios';
import { useAuth } from 'packages/novous_web/src/authContext/useAuth';
import { useSidebar } from "packages/novous_web/src/context/SideBarContext";
import arrow from "packages/novous_web/src/assets/icons/Arrow.svg";
import calendar from "packages/novous_web/src/assets/icons/calendar.svg";
import DateRangeFilter from "../../../../common/components/DateRange";
import dayjs from "dayjs";
import { ArrowBack } from '@mui/icons-material';
import { useNavigation } from 'react-router-dom';
import CustomiseTableModal from 'packages/novous_web/src/common/components/CustomiseTable';
import EmailModal from 'packages/novous_web/src/common/components/EmailData';
import DownloadData from 'packages/novous_web/src/common/components/DownloadData';
import useApiError from 'packages/novous_web/src/api/useApiError';
import AlertToast from 'packages/novous_web/src/common/components/Alert';
import eye from 'packages/novous_web/src/assets/icons/Eye.svg'
import axiosInstance from 'packages/novous_web/src/api/apiClient';
import LiveFeedModal from './LiveFeed';

interface CustomReport {
    date_time: string;
    deviceId: string;
    vehicle: string;
    lastVideoLoc: string;
    lastLatitude: string;
    lastLongitude: string;
    totalKmToday: number;
    totalTripKm: number;
    eta: string;
    cta: string;
    totalEventsCount: number;
    overspeedingCount: number;
    farwardCollisionCount: number;
    laneDeparterCount: number;
    pedestarianCount: number;
    continiuosDrivingCount: number;
    nightDrivingCount: number;
    sosEventCount: number;
    distractedCountVp1: number;
    callToCallCountVp1: number;
    smokingCountVp1: number;
    drowsinessCountVp1: number;
    yawingCountVp1: number;
    driverWithoutSeatBeltCount: number;
    harshaccelerationFcwCount: number;
    hardBrakingFcwCount: number;
    harshTurningFcwCount: number;
    suddenStoppageCount: number;
    vehicleId: string;
    driverName: string;
    videoUrls: string,
    driverWarningType: string
}

const data: CustomReport[] = []

type ColumnObjType = {
    [key: string | number]: {
        name: string;
        status: boolean;
    };
};

interface AlertCardProps {
    driverName: string;
    vehicleNumber: string;
    dateTime: string;
    // videoUrls: string[]; // added new prop
    onPlayIconClick?: (vehicleNumber: string) => void;
}

interface EmailApiResponse {
    data: string;
    error: string;
    message: string;
    status: number;
}

const AlertCard: React.FC<AlertCardProps> = ({ vehicleNumber, onPlayIconClick }) => {
    return (
        <>
            <div className="flex justify-center items-center">
                <div className="flex justify-between gap-2">
                    <div className="flex gap-2">
                        <img
                            src={eye}
                            alt="play"
                            className="w-6 h-6 cursor-pointer"
                            onClick={() => onPlayIconClick && onPlayIconClick(vehicleNumber)}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};

export default function CustomReportCardDetal() {
    const [alertOpen, setAlertOpen] = useState<boolean>(false);
    const [alertMessage, setAlertMessage] = useState<string>("");
    const [alertType, setAlertType] = useState<"error" | "success" | "warning" | "info">("error");
    const [isSendingEmail, setIsSendingEmail] = useState(false);

    const { report_id, date_time } = useParams<{ report_id: string, date_time: string }>();
    const location = useLocation();
    const vehicleData = location.state || {};

    // State to control the LiveFeedModal
    const [isLiveFeedOpen, setIsLiveFeedOpen] = useState({ isOpen: false, tripId: "", vehicleId: "", warningSortKey: "" });
    // State to hold camera info extracted from individual SOS warning
    const [liveFeedCameraInfo, setLiveFeedCameraInfo] = useState<any[]>([]);
    // Selected state similar to TRCameraDetails
    const [selected, setSelected] = useState(2);

    const navigate = useNavigate();
    const [isCustomizeOpen, setIsCustomizeOpen] = useState(false);
    const baseDateRangeArr = [
        "Today",
        "Yesterday",
        "7 Days",
        "15 Days",
        "30 Days",
        "Custom Range",
    ];

    const [filteredDateRangeArr, setFilteredDateRangeArr] = useState(baseDateRangeArr);
    const [selectedDuration, setSelectedDuration] = useState(baseDateRangeArr[0]);
    const [calendarAnchorEl, setCalendarAnchorEl] = useState<null | HTMLElement>(null);
    const [showDatePicker, setShowDatePicker] = useState(false);
    const insightsRef = useRef<HTMLDivElement>(null);
    const [insightsWidth, setInsightsWidth] = useState<number | null>(null);
    const [startDate, setStartDate] = useState("");
    const { isSideBarOpen } = useSidebar();
    const [endDate, setEndDate] = useState("");

    const handleClosed = () => setIsCustomizeOpen(false);
    const handelCustomize = () => setIsCustomizeOpen(!isCustomizeOpen);
    const handleReset = () => console.log('Reset clicked!');

    const getDateRange = (range: string) => {
        const today = dayjs();
        let startDate, endDate;

        switch (range) {
            case "Today":
                startDate = today.format("YYYY-MM-DD");
                endDate = today.format("YYYY-MM-DD");
                break;
            case "Yesterday":
                startDate = dayjs().subtract(1, "day").format("YYYY-MM-DD");
                endDate = startDate;
                break;
            case "7 Days":
                startDate = dayjs().subtract(6, "day").format("YYYY-MM-DD");
                endDate = today.format("YYYY-MM-DD");
                break;
            case "15 Days":
                startDate = dayjs().subtract(14, "day").format("YYYY-MM-DD");
                endDate = today.format("YYYY-MM-DD");
                break;
            case "30 Days":
                startDate = dayjs().subtract(29, "day").format("YYYY-MM-DD");
                endDate = today.format("YYYY-MM-DD");
                break;
            default:
                startDate = "";
                endDate = "";
        }
        return { startDate, endDate };
    };

    const {
        data: MasterReportData,
        error: MasterReportError,
        loading: MasterReportLoading,
        fetchData: MasterReportRequestData,
    }: { data: any, error: any, loading: boolean, fetchData: any } = useAxios(API_ENDPOINTS.report.MASTER_REPORTS, "POST");

    useEffect(() => {
        MasterReportRequestData({
            fleetId: user.customer_id,
        });
    }, [])

    let { startDate: startDateC, endDate: endDateC } = getDateRange(selectedDuration);

    useEffect(() => {
        if (insightsRef.current) {
            setInsightsWidth(insightsRef.current.offsetWidth);
        }
    }, [isSideBarOpen]);

    if (startDate !== "" && endDate !== "") {
        startDateC = startDate;
        endDateC = endDate;
    } else if (startDate === "" && endDate === "") {
        ({ startDate: startDateC, endDate: endDateC } = getDateRange(selectedDuration));
    }

    useEffect(() => {
        const { startDate: newStartDate, endDate: newEndDate } = getDateRange(selectedDuration);
        setStartDate(newStartDate);
        setEndDate(newEndDate);
    }, [selectedDuration]);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
        setCalendarAnchorEl(event.currentTarget);
    };

    const handleCalendarClose = () => {
        setShowDatePicker(false);
        // setStartDate("");
        // setEndDate("");

        // setSelectedDuration(dateRangeArr[0]);
        setCalendarAnchorEl(null);
    };

    const handleClose = (value?: string) => {
        console.log("Selected Value:", value);

        if (value) {
            // Only reset dates if changing FROM custom range TO another option
            if (selectedDuration === "Custom Range" && value !== "Custom Range") {
                const { startDate: newStartDate, endDate: newEndDate } = getDateRange(value);
                setStartDate(newStartDate);
                setEndDate(newEndDate);
            }

            setSelectedDuration(value);
            setShowDatePicker(value === "Custom Range");

            // If selecting Custom Range again, don't reset the dates - keep existing values
            if (value === "Custom Range") {
                setCalendarAnchorEl(anchorEl); // Keep the anchor for the date picker
            }
        }

        setAnchorEl(null);
    };

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const isSmallScreen = useMediaQuery("(max-width:850px)");
    const { user } = useAuth();

    interface CustomReportResponse {
        data: {
            reportName: string;
            reportDescription: string;
            date_time: string;
            selectedColumns: string[];
            reportCategory?: string;
        };
    }

    const {
        data: CustomReportData,
        error: CustomReportError,
        loading: CustomReportLoading,
        fetchData: CustomReportRequestData,
    } = useAxios<CustomReportResponse>(API_ENDPOINTS.report.CUSTOM_REPORT_DATA_SINGLE, "POST");
    console.log(CustomReportData, 'csnksnvknsdvknkdsvndkvnk')
    useEffect(() => {
        CustomReportRequestData({
            reportId: report_id,
            dateTime: date_time
        });
    }, []);

    useEffect(() => {
        if (CustomReportData?.data?.reportCategory) {
            const reportCategory = CustomReportData.data.reportCategory;

            if (reportCategory === "devicehealthreport" || reportCategory === "vehicleignitionreport" || reportCategory === "alarmreport") {
                // Remove "15 Days", "30 Days", and "Custom Range" for these categories
                setFilteredDateRangeArr(baseDateRangeArr.filter(
                    option => !["15 Days", "30 Days", "Custom Range"].includes(option)
                ));

                // Also reset selected duration if it's one of the removed options
                if (["15 Days", "30 Days", "Custom Range"].includes(selectedDuration)) {
                    setSelectedDuration("Today");
                    const { startDate: newStartDate, endDate: newEndDate } = getDateRange("Today");
                    setStartDate(newStartDate);
                    setEndDate(newEndDate);
                }
            } else {
                // For other categories, show all options
                setFilteredDateRangeArr(baseDateRangeArr);
            }
        }
    }, [CustomReportData]);

    // Initialize columnObj directly from CustomReportData
    const [columnObj, setColumnObj] = useState<ColumnObjType>(() => {
        if (!CustomReportData) return {};

        const columns = (CustomReportData as CustomReportResponse)?.data?.selectedColumns ?? [];
        const obj: ColumnObjType = {};

        columns.forEach((column: string) => {
            const formattedLabel = column
                .replace(/([A-Z])/g, ' $1')
                .replace(/(Count|Vp1|Fcw|Km)/g, ' $1')
                .replace(/^./, str => str.toUpperCase())
                .trim()
                .replace(/ Count$/, '')
                .replace(/ Vp1$/, '')
                .replace(/ Fcw$/, '');

            obj[column] = { name: formattedLabel, status: true };
        });

        return obj;
    });

    // Update columnObj when CustomReportData changes
    useEffect(() => {
        if (CustomReportData) {
            const columns = (CustomReportData as CustomReportResponse)?.data?.selectedColumns ?? [];
            const newColumnObj: ColumnObjType = {};

            columns.forEach((column: string) => {
                const formattedLabel = column
                    .replace(/([A-Z])/g, ' $1')
                    .replace(/(Count|Vp1|Fcw|Km)/g, ' $1')
                    .replace(/^./, str => str.toUpperCase())
                    .trim()
                    .replace(/ Count$/, '')
                    .replace(/ Vp1$/, '')
                    .replace(/ Fcw$/, '');

                // Preserve existing status if column already exists
                newColumnObj[column] = {
                    name: formattedLabel,
                    status: columnObj[column]?.status ?? true
                };
            });

            setColumnObj(newColumnObj);
        }
    }, [CustomReportData]);

    // const processedData = useMemo(() => {
    //     if (!CustomReportData) return [];
    //     const matchedMasterReport = MasterReportData?.data?.find(
    //         (report: any) => report.reportName === CustomReportData.data?.reportCategory
    //     );
    //     const columns = (CustomReportData as CustomReportResponse)?.data?.selectedColumns ?? [];

    //     return columns
    //         .filter((column: string) => columnObj[column]?.status !== false)
    //         .map((column: string) => {
    //             const matchedColumn = matchedMasterReport?.reportWiseColumns?.all?.find(
    //                 (col: any) => col.field === column
    //             );

    //             // Use the label from MasterReportData if found, otherwise format the column name
    //             const formattedLabel = matchedColumn?.label ||
    //                 column
    //                     .replace(/([A-Z])/g, ' $1')
    //                     .replace(/(Count|Vp1|Fcw|Km)/g, ' $1')
    //                     .replace(/^./, str => str.toUpperCase())
    //                     .trim()
    //                     .replace(/ Count$/, '')
    //                     .replace(/ Vp1$/, '')
    //                     .replace(/ Fcw$/, '');

    //             return {
    //                 id: column,
    //                 value: formattedLabel
    //             };
    //         });
    // }, [CustomReportData, columnObj, MasterReportData]);

    const [isCheckingVideos, setIsCheckingVideos] = useState(false);

    const formatWarningSortKey = (warningSortKey: string) => {
        if (!warningSortKey) return '';
        const parts = warningSortKey.split('_');

        if (parts.length !== 6) return warningSortKey;
        const [year, month, day, hour, minute, second] = parts;
        return `${year}-${month}-${day}:${hour}:${minute}:${second}`;
    };

    const handleOpenLiveFeed = async (vehicleId: string, warningSortKey: string, warningString: string, videoFileName: string) => {

        setIsLiveFeedOpen({ isOpen: true, tripId: vehicleId, vehicleId: vehicleId, warningSortKey: warningSortKey });
        setIsCheckingVideos(true);

        if (!videoFileName) {
            console.log('No video file name available');
            setLiveFeedCameraInfo([]);
            setIsCheckingVideos(false);
            return;
        }

        try {
            const response = await axiosInstance({
                url: API_ENDPOINTS.alarm.ALERTS_VIDE0_URL_SECONDARY,
                method: "POST",
                data: {
                    vehicleId: vehicleId,
                    timestamp: formatWarningSortKey(warningSortKey),
                    alertType: warningString,
                    fileNames: videoFileName,
                },
                responseType: "json"
            });

            const videoUrlsFromApi = Array.isArray(response.data.data) ? response.data.data : [];

            const cameraInfo = videoUrlsFromApi.map((url: string) => {
                const fileName = url.split("/").pop()?.split("?")[0] || "";
                const segments = fileName.split("_");
                const cameraCode = segments[1] || "Unknown";
                const cameraMapping: Record<string, string> = {
                    "01": "ADAS",
                    "02": "CAM3",
                    "03": "CAM4",
                    "04": "(DMS)",
                };
                const cameraId = cameraMapping[cameraCode] || "Unknown";
                return { cameraId, cameraName: cameraId, playBackUrl: url };
            });

            setLiveFeedCameraInfo(cameraInfo);
            setSelected(0);
        } catch (error) {
            console.error('Error fetching video URLs:', error);
            setLiveFeedCameraInfo([]);
            setIsCheckingVideos(false);
        }
    };

    const handleLiveFeedClose = () => {
        setIsLiveFeedOpen({ isOpen: false, tripId: "", vehicleId: "", warningSortKey: "" });
        setSelected(2);
    };

    // const processedData = useMemo(() => {
    //     if (!CustomReportData) return [];
    //     const matchedMasterReport = MasterReportData?.data?.find(
    //         (report: any) => report.reportName === CustomReportData.data?.reportCategory
    //     );
    //     const columns = (CustomReportData as CustomReportResponse)?.data?.selectedColumns ?? [];

    //     // Separate videoUrls from other columns
    //     const videoUrlColumn = columns.find((column: string) => column === 'videoUrls');
    //     const otherColumns = columns.filter((column: string) => column !== 'videoUrls');

    //     // Process other columns first
    //     const processedColumns = otherColumns
    //         .filter((column: string) => columnObj[column]?.status !== false)
    //         .map((column: string) => {
    //             const matchedColumn = matchedMasterReport?.reportWiseColumns?.all?.find(
    //                 (col: any) => col.field === column
    //             );

    //             // Use the label from MasterReportData if found, otherwise format the column name
    //             const formattedLabel = matchedColumn?.label ||
    //                 column
    //                     .replace(/([A-Z])/g, ' $1')
    //                     .replace(/(Count|Vp1|Fcw|Km)/g, ' $1')
    //                     .replace(/^./, str => str.toUpperCase())
    //                     .trim()
    //                     .replace(/ Count$/, '')
    //                     .replace(/ Vp1$/, '')
    //                     .replace(/ Fcw$/, '');

    //             return {
    //                 id: column,
    //                 value: formattedLabel
    //             };
    //         });

    //     // Add videoUrls column at the end if it exists and is enabled
    //     if (videoUrlColumn && columnObj[videoUrlColumn]?.status !== false) {
    //         const matchedColumn = matchedMasterReport?.reportWiseColumns?.all?.find(
    //             (col: any) => col.field === videoUrlColumn
    //         );

    //         const formattedLabel = matchedColumn?.label || 'Video URLs';

    //         processedColumns.push({
    //             id: videoUrlColumn,
    //             value: formattedLabel
    //         });
    //     }

    //     return processedColumns;
    // }, [CustomReportData, columnObj, MasterReportData]);

    const processedData = useMemo(() => {
        if (!CustomReportData) return [];
        const matchedMasterReport = MasterReportData?.data?.find(
            (report: any) => report.reportName === CustomReportData.data?.reportCategory
        );
        const columns = (CustomReportData as CustomReportResponse)?.data?.selectedColumns ?? [];

        // Track occurrences of each field name to handle duplicates
        const fieldOccurrenceMap: Record<string, number> = {};

        const processedColumns = columns
            .filter((column: string) => columnObj[column]?.status !== false)
            .map((column: string) => {
                // Count how many times this field has appeared
                fieldOccurrenceMap[column] = (fieldOccurrenceMap[column] || 0) + 1;
                const currentOccurrence = fieldOccurrenceMap[column];

                // Find ALL matching columns in master report
                const allMatchingColumns = matchedMasterReport?.reportWiseColumns?.all?.filter(
                    (col: any) => col.field === column
                ) || [];

                let formattedLabel;

                if (allMatchingColumns.length > 0) {
                    // For duplicate fields, use the label based on occurrence order
                    if (allMatchingColumns.length >= currentOccurrence) {
                        formattedLabel = allMatchingColumns[currentOccurrence - 1]?.label;
                    } else {
                        // If more occurrences than available labels, use the last available label
                        formattedLabel = allMatchingColumns[allMatchingColumns.length - 1]?.label;
                    }
                } else {
                    // Fallback to formatting the column name if no match found
                    formattedLabel = column
                        .replace(/([A-Z])/g, ' $1')
                        .replace(/(Count|Vp1|Fcw|Km)/g, ' $1')
                        .replace(/^./, str => str.toUpperCase())
                        .trim()
                        .replace(/ Count$/, '')
                        .replace(/ Vp1$/, '')
                        .replace(/ Fcw$/, '');
                }

                return {
                    id: column,
                    value: formattedLabel
                };
            });

        return processedColumns;
    }, [CustomReportData, columnObj, MasterReportData]);

    // const columns: MRT_ColumnDef<CustomReport>[] = useMemo(() => {
    //     const warningColumns: MRT_ColumnDef<CustomReport>[] = processedData.map((processedValue) => ({

    //         accessorKey: processedValue.id,
    //         header: processedValue.value,
    //         enableColumnActions: false,
    //         size: isSmallScreen ? 90 : 220,
    //         muiTableBodyCellProps: { sx: { maxWidth: '200px', padding: '8px', overflow: 'hidden' } },
    //         Cell: ({ cell }: { cell: MRT_Cell<CustomReport> }) => (
    //             <Typography className="truncate" variant="body2" fontWeight={400} noWrap>
    //                 {cell.getValue<string>()}
    //             </Typography>
    //         )
    //     }));
    //     return [...warningColumns];
    // }, [processedData, isSmallScreen]);

    const columns: MRT_ColumnDef<CustomReport>[] = useMemo(() => {
        const warningColumns: MRT_ColumnDef<CustomReport>[] = processedData.map((processedValue) => {
            if (processedValue.id === 'videoUrls') {
                return {
                    accessorKey: processedValue.id,
                    header: processedValue.value,
                    enableColumnActions: false,
                    size: isSmallScreen ? 90 : 120,
                    muiTableBodyCellProps: { sx: { padding: '8px', textAlign: 'center' } },
                    Cell: ({ cell }: { cell: MRT_Cell<CustomReport> }) => {
                        const value = cell.getValue<string>();
                        return value !== "" ? (
                            <AlertCard
                                key={cell?.row?.original?.vehicleId}
                                driverName={cell?.row?.original?.driverName || "NA"}
                                vehicleNumber={cell?.row?.original?.vehicleId}
                                dateTime={cell?.row?.original?.date_time}
                                // videoUrls={cell?.row?.original?.videoUrls || []}
                                onPlayIconClick={() => handleOpenLiveFeed(
                                    cell?.row?.original?.vehicleId,
                                    // cell?.row?.original?.videoUrls || [],
                                    cell?.row?.original?.date_time,
                                    cell?.row?.original?.driverWarningType,
                                    cell?.row?.original?.videoUrls,
                                )}
                            />
                            // <img src={eye} alt='' />
                        ) : (
                            <Typography variant="body2" fontWeight={400}>
                                -
                            </Typography>
                        );
                    }
                };
            }

            if (processedValue.id === 'warningStatus') {
                return {
                    accessorKey: processedValue.id,
                    header: processedValue.value,
                    enableColumnActions: false,
                    size: isSmallScreen ? 90 : 120,
                    muiTableBodyCellProps: { sx: { padding: '8px' } },
                    Cell: ({ cell }: { cell: MRT_Cell<CustomReport> }) => {
                        const value = cell.getValue<boolean>();
                        return (
                            <Chip
                                label={value ? "True" : "False"}
                                size="small"
                                color={value ? "success" : "error"}
                                variant="outlined"
                            />
                        );
                    }
                };
            }

            if (processedValue.id === 'date_time') {
                return {
                    accessorKey: processedValue.id,
                    header: processedValue.value,
                    enableColumnActions: false,
                    size: isSmallScreen ? 90 : 120,
                    muiTableBodyCellProps: { sx: { padding: '8px' } },
                    Cell: ({ cell }: { cell: MRT_Cell<CustomReport> }) => {
                        const rawValue = cell.getValue<string>();
                        
                        const [year, month, day] = rawValue.split('_');
                        const date = new Date(`${year}-${month}-${day}`);
                        const formattedDate = date.toLocaleDateString('en-GB', {
                            day: '2-digit',
                            month: 'long',
                            year: 'numeric',
                        });

                        return <Typography variant="body2" fontWeight={400} noWrap>{formattedDate}</Typography>;
                    }
                };
            }

            return {
                accessorKey: processedValue.id,
                header: processedValue.value,
                enableColumnActions: false,
                size: isSmallScreen ? 90 : 220,
                muiTableBodyCellProps: { sx: { maxWidth: '200px', padding: '8px', overflow: 'hidden' } },
                Cell: ({ cell }: { cell: MRT_Cell<CustomReport> }) => (
                    <Typography className="truncate" variant="body2" fontWeight={400} noWrap>
                        {cell.getValue<string>()}
                    </Typography>
                )
            };
        });

        return [...warningColumns];
    }, [processedData, isSmallScreen]);

    const paginatedArr = useRef<(string | null)[]>([null]);
    const [paginationKeys, setPaginationKeys] = useState<{ [key: number]: string | null }>({ 1: null });
    const [currentPage, setCurrentPage] = useState(1);

    interface CustomerReportResponseData {
        data: {
            reportData: CustomReport[];
            lastEvaluatedKey: string | null;
            date_time: string
        }
    }

    const {
        data: managerReportData,
        error: managerReportError,
        loading: managerReportLoading,
        fetchData: managerReportRequestData,
    } = useAxios<CustomerReportResponseData>(API_ENDPOINTS.report.CUSTOM_REPORT_DATA_VALUE, "POST");

    // useEffect(() => {
    //     managerReportRequestData({
    //         reportId: report_id,
    //         startDate: startDateC,
    //         endDate: endDateC,
    //         dateTime: CustomReportData?.data?.date_time
    //     });
    // }, []);

    useEffect(() => {
        if (managerReportData?.data?.lastEvaluatedKey) {
            // Store the lastEvaluatedKey for the next page
            const nextPage = currentPage + 1;
            const lastEvaluatedKeyStr = JSON.stringify(managerReportData.data.lastEvaluatedKey);
            if (paginationKeys[nextPage] !== lastEvaluatedKeyStr) {
                setPaginationKeys(prev => ({
                    ...prev,
                    [nextPage]: lastEvaluatedKeyStr
                }));
            }
        }
    }, [managerReportData, currentPage]);

    const totalPages = managerReportData?.data?.lastEvaluatedKey
        ? Object.keys(paginationKeys).length
        : currentPage;

    const handlePageChange = async (event: React.ChangeEvent<unknown>, page: number) => {
        if (page === currentPage || managerReportLoading) return;

        setCurrentPage(page)
        const keyForTargetPage = paginationKeys[page];

        await managerReportRequestData({
            reportId: report_id,
            startDate: startDate || startDateC,
            endDate: endDate || endDateC,
            lastEvaluatedKey: keyForTargetPage ? JSON.parse(keyForTargetPage) : null,
            dateTime: date_time
        });
    };

    useEffect(() => {
        const fetchData = async () => {
            if (startDate && endDate) {
                setCurrentPage(1);
                setPaginationKeys({ 1: null });  // ✅ Clear previous pagination keys

                try {
                    await managerReportRequestData({
                        reportId: report_id,
                        startDate,
                        endDate,
                        lastEvaluatedKey: null,
                        dateTime: date_time
                    });
                } catch (error) {
                    console.error("Failed to fetch report data:", error);
                }
            }
        };

        fetchData();
    }, [startDate, endDate]);

    const processedDataValue = useMemo(() => {
        if (!managerReportData?.data?.reportData) return [];

        return managerReportData.data.reportData.map((report) => {
            if (!report.date_time || typeof report.date_time !== 'string') {
                return {
                    ...report,
                    date_time: '',
                    totalEventsCount: report.totalEventsCount || 0,
                };
            }

            try {
                const [year, month, day] = report.date_time.split('_');
                const formattedDate = dayjs(`${year}-${month}-${day}`).format('DD MMMM YYYY');
                return {
                    ...report,
                    date_time: report.date_time,
                    totalEventsCount: report.totalEventsCount || 0,
                };
            } catch (error) {
                console.error('Error formatting date:', error);
                return {
                    ...report,
                    date_time: report.date_time,
                    totalEventsCount: report.totalEventsCount || 0,
                };
            }
        });
    }, [managerReportData]);

    const tableOptions: MRT_TableOptions<CustomReport> = {
        columns,
        data: processedDataValue,
        enablePagination: false,
        enableColumnFilters: false,
        enableSorting: false,
        enableGlobalFilter: false,
        enableDensityToggle: false,
        enableHiding: false,
        enableBottomToolbar: false,
        enableTopToolbar: false,
        enableFullScreenToggle: false,
        enableToolbarInternalActions: false,
        enableColumnPinning: true,
        initialState: {
            columnPinning: {
                left: columns.slice(0, 3).map(col => col.accessorKey as string),
                right: columns.slice(-4).map(col => col.accessorKey as string),
            },
        },
        muiTableBodyProps: {
            sx: {
                padding: 0,
                margin: 0,
            },
        },
        muiTableProps: {
            sx: {
                overflow: 'scroll',
            },
        },
    };

    const [openEmailModal, setOpenEmailModal] = useState(false);
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

    const {
        data: sendEmailReportManager,
        error: sendEmailReportManagerError,
        loading: sendEmailReportManagerLoading,
        fetchData: fetchSendEmailReportManagerData,
    } = useApiError<EmailApiResponse>(`${API_ENDPOINTS.report.CUSTOM_REPORT_SEND_EMAIL}`, "POST");

    const handleEmailModalOpen = () => setOpenEmailModal(true);
    const handleEmailModalClose = () => setOpenEmailModal(false);

    const handleSendEmail = async (email: string, message: string) => {
        setIsSendingEmail(true);
        if (!emailRegex.test(email)) {
            alert("Please enter a valid email address (e.g., user@example.com).");
            return;
        }

        const domainPart = email.split('@')[1];
        const domainRegex = /^[a-zA-Z0-9-]+\.(com)$/;

        if (
            domainPart &&
            (!domainRegex.test(domainPart) || domainPart.split('.').length !== 2)
        ) {
            setAlertMessage("Invalid domain. Email domain must end exactly with '.com' and contain no extra characters after '.com'");
            setAlertType("error");
            setAlertOpen(true);
            setIsSendingEmail(false);
            return;
        }

        try {
            const response = await fetchSendEmailReportManagerData({
                reportId: report_id,
                reportCategory: CustomReportData?.data?.reportCategory,
                fleetId: user?.customer_id,
                vehicleId: vehicleData?.vehicleRegistrationNo,
                email: email,
                emailMessage: message,
                startDate,
                endDate,
            });

            if (response?.status === 201) {
                setAlertMessage(response?.message);
                setAlertType("success");
                setAlertOpen(true);
                setOpenEmailModal(false);
            } else {
                setAlertMessage(response?.error);
                setAlertType("error");
                setAlertOpen(true);
                setOpenEmailModal(false);
            }
        } catch (error) {
            console.error("Error sending email:", error);
            setAlertMessage((error as Error).message);
            setAlertType("error");
            setAlertOpen(true);
        } finally {
            setIsSendingEmail(false);
        }
    };

    const [isDownloadModalOpen, setIsDownloadModalOpen] = useState(false);
    const [selectedFormat, setSelectedFormat] = useState<string>('pdf');
    const {
        data: downloadCustomReportData,
        error: downloadCustomReportError,
        loading: downloadCustomReportLoading,
        fetchData: fetchDownloadCustomReportData,
    } = useApiError<any>(`${API_ENDPOINTS.report.CUSTOM_REPORT_SEND_DOWNLOAD}`, "POST", 'blob');

    const handleDownload = async () => {
        setIsSendingEmail(true);
        const requestData = {
            reportId: report_id,
            reportCategory: CustomReportData?.data?.reportCategory,
            fleetId: user?.customer_id,
            fileType: selectedFormat,
            vehicleId: vehicleData?.vehicleRegistrationNo,
            startDate,
            endDate,
            dateTime: date_time
        };

        try {
            const response = await fetchDownloadCustomReportData(requestData);
            if (response?.type === 'text/csv' || response?.type === 'application/pdf' || response?.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
                setAlertMessage(`File has been downloaded successfully`);
                setAlertType("success");
                setAlertOpen(true);
            } else {
                setAlertMessage(response?.error);
                setAlertType("error");
                setAlertOpen(true);
            }
        } catch (error) {
            console.error("Error sending email:", error);
            setAlertMessage((error as Error).message);
            setAlertType("error");
            setAlertOpen(true);
        } finally {
            setIsSendingEmail(false);
        }
    };

    const handleFormatChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSelectedFormat(event.target.value);
    };

    useEffect(() => {
        if (downloadCustomReportData) {
            try {
                if (downloadCustomReportData instanceof Blob) {
                    const url = window.URL.createObjectURL(downloadCustomReportData);
                    const a = document.createElement('a');
                    a.href = url;
                    let extension = selectedFormat.toLowerCase();
                    if (extension === 'excel') {
                        extension = 'xlsx'; // Use xlsx for Excel format
                    }

                    const fileName = `Custom-Report.${extension}`;
                    a.download = fileName;
                    document.body.appendChild(a);
                    a.click();
                    window.URL.revokeObjectURL(url);
                    document.body.removeChild(a);
                } else {
                    console.error('Invalid response format. Expected a Blob.');
                }
            } catch (error) {
                console.error('Error downloading file:', error);
            } finally {
                setIsDownloadModalOpen(false);
            }
        }
    }, [downloadCustomReportData])

    const handleDownloadModalClose = () => {
        if (downloadCustomReportLoading) {
            return;
        }
        setIsDownloadModalOpen(false);
    };

    const table = useMaterialReactTable(tableOptions);

    return (
        <>
            <AlertToast message={alertMessage} type={alertType} open={alertOpen} onClose={() => setAlertOpen(false)} />
            <div className='flex flex-col gap-4 w-full'>
                <div className="w-full mt-4">
                    <button className="text-blue-600 font-medium flex items-center" onClick={() => navigate(-1)}>
                        <ArrowBack className="mr-1" /> Back
                    </button>
                </div>
                <div className='w-full flex lg:flex-row md:flex-row flex-col justify-between gap-4 xs:flex-col items-start'>
                    <div className="max-w-max">
                        <div className="dashboard-header-left">
                            <div className="flex flex-col items-start">
                                <Typography variant="h4" fontSize="24px" fontWeight={600} lineHeight='36px'>
                                    {CustomReportData?.data?.reportName}
                                </Typography>
                                <Typography variant="subtitle1" fontSize={16} fontWeight={400} lineHeight='24px'>
                                    {CustomReportData?.data?.reportDescription}
                                </Typography>
                            </div>
                        </div>
                    </div>
                    <div className="flex gap-4 flex-wrap">
                        <CustomIconButton
                            icon={<img src={Custom} alt="Custom" width={16} height={16} />}
                            text="Customize"
                            background='transparent'
                            outline={false}
                            onClick={handelCustomize}
                        />
                        <CustomiseTableModal
                            open={isCustomizeOpen}
                            onClose={handleClosed}
                            onReset={handleReset}
                            title="Customize Your Table"
                            description="Select and arrange table columns as you prefer."
                            columnObj={columnObj}
                            setColumnObj={setColumnObj}
                        />
                        <CustomIconButton
                            icon={<img src={emailReportIcon} alt="Custom" width={16} height={16} />}
                            text="Email report"
                            background='transparent'
                            outline={false}
                            onClick={handleEmailModalOpen}
                        />
                        <EmailModal
                            open={openEmailModal}
                            onClose={handleEmailModalClose}
                            onSend={handleSendEmail}
                            title="Email Report"
                            description="Enter the recipient's email address and an optional message to accompany the report."
                            isSending={isSendingEmail}
                        />

                        {selectedDuration === "Custom Range" && (
                            <div className="flex items-center">
                                <Box
                                    sx={(theme) => ({
                                        backgroundColor: theme.palette.selected,
                                        borderRadius: "8px",
                                        padding: theme.spacing(1),
                                    })}
                                >
                                    <Typography
                                        variant="subtitle2"
                                        className="truncate"
                                        sx={{ fontWeight: 700, marginRight: 1 }}
                                    >
                                        <span style={{ color: "#235AF9" }}>
                                            {startDateC} - {endDateC}
                                        </span>
                                    </Typography>
                                </Box>
                            </div>
                        )}

                        <div className="relative">
                            <Button
                                onClick={handleClick}
                                variant="outlined"
                                sx={{
                                    height: { xs: "28px", sm: "30px", md: "48px" },
                                    px: { xs: 1, sm: 2 },
                                    borderRadius: "8px",
                                    textTransform: "none",
                                    fontWeight: 700,
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: { xs: 0.5, sm: 1 },
                                    borderColor: "#5547dd",
                                    backgroundColor: "white",
                                    color: "#5547dd",
                                    minWidth: 0,
                                    maxWidth: "100%",
                                }}
                            >
                                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                    <img src={calendar} alt="Calendar" width={18} height={18} />
                                    <Box sx={{ display: "block", maxWidth: "100%" }}>
                                        <Typography
                                            variant="body2"
                                            sx={{
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                            }}
                                        >
                                            {selectedDuration}
                                        </Typography>
                                    </Box>
                                    <img src={arrow} alt="Arrow" width={18} height={18} />
                                </Box>
                            </Button>

                            <Menu
                                anchorEl={anchorEl}
                                open={Boolean(anchorEl)}
                                onClose={() => handleClose()}
                                PaperProps={{
                                    sx: {
                                        borderRadius: "8px",
                                        top: "10px",
                                        boxShadow: "0 6px 10px rgba(0, 0, 0, 0.1)",
                                    },
                                }}
                            >
                                {filteredDateRangeArr.map((label) => (
                                    <MenuItem
                                        key={label}
                                        onClick={() => handleClose(label)}
                                        sx={(theme) => ({
                                            transition: "all 0.2s ease-in-out",
                                            "&:hover": {
                                                backgroundColor: theme.palette.action.hover,
                                            },
                                            backgroundColor: selectedDuration === label ? theme.palette.selected : 'transparent',
                                        })}
                                    >
                                        <Typography variant="button" textTransform={"none"}>
                                            {label}
                                        </Typography>
                                    </MenuItem>
                                ))}
                            </Menu>
                            <Menu
                                anchorEl={calendarAnchorEl}
                                open={showDatePicker}
                                onClose={handleCalendarClose}
                                slotProps={{
                                    paper: {
                                        sx: {
                                            borderRadius: "8px",
                                            top: "10px",
                                            padding: "0px",
                                            boxShadow: "0 6px 10px rgba(0, 0, 0, 0.1)",
                                        },
                                    },
                                }}
                            >
                                <DateRangeFilter
                                    onCancel={handleCalendarClose}
                                    onApply={(from, to) => {
                                        setStartDate(from);
                                        setEndDate(to);
                                        setSelectedDuration("Custom Range");
                                        setShowDatePicker(false);
                                        setCalendarAnchorEl(null);
                                    }}
                                    initialFrom={startDate}
                                    initialTo={endDate}
                                />
                            </Menu>
                        </div>
                        <CustomIconButton
                            icon={<img src={downloadWhiteIcon} alt="download" width={16} height={16} />}
                            text="Download"
                            variant='contained'
                            onClick={() => setIsDownloadModalOpen(!isDownloadModalOpen)}
                        />
                    </div>
                </div>

                <DownloadData
                    downloadLoading={downloadCustomReportLoading}
                    isDownloadModalOpen={isDownloadModalOpen}
                    handleDownloadModalClose={handleDownloadModalClose}
                    selectedFormat={selectedFormat}
                    handleFormatChange={handleFormatChange}
                    handleDownload={handleDownload}
                    modalTitle="Download Trips Data"
                    modalDescription="Please select a file format for your download."
                    formatLabel="Format"
                    formatExcelLabel="Excel"
                    formatCsvLabel="CSV"
                    formatPdfLabel="PDF"
                    cancelButtonText="Cancel"
                    downloadButtonText="Download"
                />

                <MaterialReactTable table={table} />
            </div>

            <Box display="flex" justifyContent="center" mt={2}>
                <Pagination
                    count={totalPages}
                    page={currentPage}
                    onChange={handlePageChange}
                    shape="rounded"
                    color="primary"
                    siblingCount={0}
                    boundaryCount={0}
                    renderItem={(item) => {
                        if (item.type === "page" && item.page !== null && item.page > currentPage) {
                            return null;
                        }
                        return <PaginationItem {...item} />;
                    }}
                />
            </Box>
            <LiveFeedModal
                type="alert"
                alertName="Alert Evidence Video2"
                selectedCamera={selected}
                trip={isLiveFeedOpen}
                cameraInfo={liveFeedCameraInfo}
                isDash={true}
                open={isLiveFeedOpen.isOpen}
                onClose={handleLiveFeedClose}
                isCheckingVideos={isCheckingVideos}
            />
        </>
    );
}